<template>
  <span class="wbw">
    <span
        v-for="(w, i) in revealed"
        :key="i"
        class="fade-word"
        v-html="w"
    ></span>
  </span>
</template>

<script>
export default {
  name: "WordByWord",
  props: {
    text: { type: String, required: true },
    speed: { type: Number, default: 80 },          // ms between word reveals
    startDelay: { type: Number, default: 0 },      // optional stagger per item
    wordsPerStep: { type: Number, default: 1 },    // show N words per tick
    trim: { type: Boolean, default: true },        // trim leading/trailing spaces
    pauseOnPunctuation: { type: Boolean, default: true },
    punctuationPauses: {
      type: Object,
      default: () => ({ ".": 220, ",": 120, ";": 140, ":": 140, "!": 200, "?": 200, "\n": 150 })
    }
  },
  data() {
    return { tokens: [], idx: 0, revealed: [], timer: null };
  },
  computed: {
    src() {
      const s = this.text || "";
      return this.trim ? s.trim() : s;
    }
  },
  watch: {
    src: {
      immediate: true,
      handler() { this.restart(); }
    }
  },
  methods: {
    clearTimer() { if (this.timer) { clearTimeout(this.timer); this.timer = null; } },
    tokenize() {
      // Preserve words with their trailing whitespace
      const re = /\S+\s*/g; // word + its trailing whitespace; preserves newlines
      const list = [];
      let m;
      while ((m = re.exec(this.src)) !== null) list.push(m[0]);
      if (list.length === 0 && this.src) list.push(this.src); // all whitespace case
      this.tokens = list;
    },
    restart() {
      this.clearTimer();
      this.revealed = [];
      this.idx = 0;
      if (!this.src) { this.tokens = []; return; }
      this.tokenize();
      this.timer = setTimeout(this.tick, this.startDelay);
    },
    nextPause(token) {
      if (!this.pauseOnPunctuation || !token) return 0;
      const ch = token.replace(/\s+$/, "").slice(-1);
      return this.punctuationPauses[ch] || 0;
    },
    tick() {
      if (this.idx >= this.tokens.length) return;
      for (let k = 0; k < this.wordsPerStep && this.idx < this.tokens.length; k++) {
        const token = this.tokens[this.idx++];
        this.revealed.push(token);
      }
      if (this.idx >= this.tokens.length) {
        this.$emit("finished");
        return;
      }
      const pause = this.nextPause(this.revealed[this.revealed.length - 1]);
      this.timer = setTimeout(this.tick, this.speed + pause);
    }
  },
  beforeDestroy() { this.clearTimer(); }
};
</script>

<style scoped>
.wbw {
  white-space: pre-wrap;   /* keeps \n from your API and wraps nicely */
  word-break: break-word;
}

.fade-word {
  opacity: 0;
  display: inline;
  animation: fadeIn 0.4s ease forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>